import { NavLink, Link } from "react-router-dom";
import { Leaf } from "lucide-react";

export const NAV = [
  { to: "/", label: "Lookup", iconKey: "Search", testId: "nav-lookup", end: true },
  { to: "/bulk", label: "Bulk CSV", iconKey: "Upload", testId: "nav-bulk" },
  { to: "/history", label: "History", iconKey: "History", testId: "nav-history" },
  { to: "/ranges", label: "Ranges", iconKey: "Layers", testId: "nav-ranges" },
];

export function SidebarNavItem({ item, Icon }) {
  return (
    <NavLink
      to={item.to}
      end={item.end}
      data-testid={item.testId}
      className={({ isActive }) =>
        `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-all duration-200 ${
          isActive
            ? "bg-[#1A3626] text-white shadow-sm"
            : "text-[#111812] hover:bg-[#F4F5F4]"
        }`
      }
    >
      <Icon className="h-4 w-4" strokeWidth={1.5} />
      <span>{item.label}</span>
    </NavLink>
  );
}

export function MobileNavItem({ item, Icon }) {
  return (
    <NavLink
      to={item.to}
      end={item.end}
      data-testid={`${item.testId}-mobile`}
      className={({ isActive }) =>
        `p-2 rounded-md ${isActive ? "bg-[#1A3626] text-white" : "text-[#5B695E]"}`
      }
    >
      <Icon className="h-4 w-4" strokeWidth={1.5} />
    </NavLink>
  );
}

export function SidebarBrand() {
  return (
    <div className="px-6 py-8 border-b border-border/60">
      <Link to="/" className="flex items-center gap-3" data-testid="sidebar-logo">
        <div className="h-10 w-10 rounded-xl bg-[#1A3626] flex items-center justify-center text-white shadow-sm">
          <Leaf className="h-5 w-5" strokeWidth={1.5} />
        </div>
        <div>
          <div className="font-heading text-lg leading-tight tracking-tight text-[#111812]">
            Wetland<span className="text-[#8A9A86]">.lookup</span>
          </div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-[#5B695E]">Collier County</div>
        </div>
      </Link>
    </div>
  );
}

export function SidebarFooter() {
  return (
    <div className="mt-auto m-4 rounded-xl overflow-hidden border border-border/60 relative">
      <img
        src="https://images.unsplash.com/photo-1767917920882-dd37fb10e597?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxzd2FtcCUyMGZvcmVzdCUyMGFlcmlhbHxlbnwwfHx8fDE3Nzc1NTY2MDd8MA&ixlib=rb-4.1.0&q=85"
        alt="Florida wetlands"
        className="w-full h-32 object-cover"
      />
      <div className="p-3 text-xs text-[#5B695E] bg-white">
        Data sourced live from the Florida Department of Environmental Protection.
      </div>
    </div>
  );
}
